// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  background-color: #FFC61D;
  border-radius: 18px;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  gap: 0.5rem;
  box-shadow: 0px 8px 8px rgba(0, 0, 0, 0.3019607843);
}
.container img {
  height: 100%;
  border-radius: 0.5rem;
}
.container .content {
  text-align: center;
  color: #161615;
  font-weight: bold;
  font-size: 14px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.container .content ion-button {
  max-width: -webkit-max-content;
  max-width: -moz-max-content;
  max-width: max-content;
  font-family: "Montserrat", sans-serif;
  font-size: 12px;
  --background: #161615;
  opacity: 1;
  --color: white;
  --border-radius: 1rem;
  font-weight: bold;
  letter-spacing: 0;
  margin: auto;
}
.container .content ion-button.button-disabled {
  opacity: 0.7;
}

@media (max-width: 365px) {
  .container img {
    width: 40%;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/home/scratch/scratch.component.scss"],"names":[],"mappings":"AAAA;EACE,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,aAAA;EACA,8BAAA;EACA,WAAA;EACA,mDAAA;AACF;AAAE;EACE,YAAA;EACA,qBAAA;AAEJ;AACE;EACE,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;AACJ;AAAI;EACE,8BAAA;EAAA,2BAAA;EAAA,sBAAA;EACA,qCAAA;EACA,eAAA;EACA,qBAAA;EACA,UAAA;EACA,cAAA;EACA,qBAAA;EACA,iBAAA;EACA,iBAAA;EACA,YAAA;AAEN;AADM;EACE,YAAA;AAGR;;AAGA;EACE;IACE,UAAA;EAAF;AACF","sourcesContent":[".container {\n  background-color: #FFC61D;\n  border-radius: 18px;\n  padding: 1rem;\n  display: flex;\n  justify-content: space-between;\n  gap: 0.5rem;\n  box-shadow: 0px 8px 8px #0000004d;\n  img {\n    height: 100%;\n    border-radius: 0.5rem;\n  }\n\n  .content {\n    text-align: center;\n    color: #161615;\n    font-weight: bold;\n    font-size: 14px;\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n    ion-button {\n      max-width: max-content;\n      font-family: \"Montserrat\", sans-serif;\n      font-size: 12px;\n      --background: #161615;\n      opacity: 1;\n      --color: white;\n      --border-radius: 1rem;\n      font-weight: bold;\n      letter-spacing: 0;\n      margin: auto;\n      &.button-disabled {\n        opacity: 0.7;\n      }\n    }\n  }\n}\n\n@media (max-width: 365px){\n  .container img{\n    width: 40%;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
